import { CreateLoanRow } from '@willow/types-iso';

import { LoanWarn } from '../../../shared/apiWarnings';
import { getParsedFields } from '../CreateLoanCrossFieldParser';

export const validateAuthorizedContactFields = (data: CreateLoanRow, warn: LoanWarn) => {
  const parsed = getParsedFields(data, [
    'constructionLoanType',
    'builderCompanyName',
    'builderAddressLine1',
    'builderAddressLine2',
    'builderAddressCity',
    'builderAddressState',
    'builderAddressZip',
    'builderEmail',
    'builderPhone',
    'builderEmailConsent',
    'builderIsResponsibleForPayment',
  ]);

  if (!parsed) return;

  const {
    constructionLoanType,
    builderCompanyName,
    builderAddressLine1,
    builderAddressLine2,
    builderAddressCity,
    builderAddressState,
    builderAddressZip,
    builderPhone,
    builderIsResponsibleForPayment,
  } = parsed;

  const isConstructionLoan = constructionLoanType != null;

  if (!isConstructionLoan && builderIsResponsibleForPayment) {
    warn('BUILDER_STATEMENTS_NOT_SUPPORTED');
  }

  if (
    !builderCompanyName &&
    [
      builderAddressLine1,
      builderAddressLine2,
      builderAddressCity,
      builderAddressState,
      builderAddressZip,
      builderPhone,
    ].some((f) => f != null)
  ) {
    warn('BUILDER_MISSING_COMPANY_NAME');
  }

  const REQUIRED_ADDRESS_FIELDS: (keyof CreateLoanRow)[] = [
    'builderAddressLine1',
    'builderAddressCity',
    'builderAddressState',
    'builderAddressZip',
  ];
  const hasMailingAddress = REQUIRED_ADDRESS_FIELDS.some((key) => parsed[key] != null);
  if (hasMailingAddress) {
    const missingFields: (keyof CreateLoanRow)[] = [];
    for (const key of REQUIRED_ADDRESS_FIELDS) {
      // @ts-ignore
      if (parsed[key] == null) {
        missingFields.push(key);
      }
    }
    if (missingFields.length) {
      const missingFieldsString = missingFields.map((key) => `\`${String(key)}\``).join(', ');
      warn('BUILDER_ADDRESS_INCOMPLETE', {
        message: `Builder mailing address is missing required ${
          missingFields.length > 1 ? 'fields' : 'field'
        } ${missingFieldsString}.`,
      });
    }
  }
};
